<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <div class="flex justify-center">
      <work-ui-logo />
    </div>

    <div class="padding-vertical-24">
      <h1 class="work-text-align-center">{{ 'APP.WELCOME' | translate }}</h1>
      <p class="work-text-align-center">
        {{ 'APP_WIRD_GELADEN' | translate }}
      </p>
    </div>
    <div class="flex justify-center">
      <work-ui-loading-spinner loadingState="loading" [iconSize]="40" />
    </div>
  </div>
</ion-content>
